<template>
  <div class="sticky top-16 z-30 bg-blue-50/95 backdrop-blur py-3">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav class="relative grid grid-cols-2 bg-white border border-blue-100 rounded-lg shadow-sm overflow-hidden">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          type="button"
          class="relative min-w-0 h-14 px-2 flex items-center justify-center gap-1.5 text-sm font-medium transition-colors"
          :class="activeTab === tab.key ? 'text-blue-950' : 'text-gray-500 hover:text-blue-800'"
          :aria-label="tab.label"
          @click="$emit('navigate', tab.key)"
        >
          <span class="material-symbols-outlined text-xl">{{ tab.icon }}</span>
          <span>{{ tab.label }}</span>
          <span
            v-if="activeTab === tab.key"
            class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-700"
          ></span>
        </button>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminTabNav',
  props: {
    activeTab: {
      type: String,
      required: true
    }
  },
  emits: ['navigate'],
  data() {
    return {
      tabs: [
        { key: 'overview', label: 'Overview', icon: 'insights' },
        { key: 'users', label: 'Users', icon: 'group' }
      ]
    };
  }
};
</script>
